import {
  FETCH_TRANSFER_STOCK_LOCATIONS_PENDING,
  FETCH_TRANSFER_STOCK_LOCATIONS_REJECTED,
  FETCH_TRANSFER_STOCK_LOCATIONS_FULFILLED
} from "../constants/transferStockLocations";

const initialState = {
  pending: true,
  transferStockLocations: [],
  error: {}
};

export const transferStockLocations = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case FETCH_TRANSFER_STOCK_LOCATIONS_PENDING:
      return { ...state, pending: true, error: {} };

    case FETCH_TRANSFER_STOCK_LOCATIONS_REJECTED:
      return { ...state, pending: false, error: action.error };

    case FETCH_TRANSFER_STOCK_LOCATIONS_FULFILLED:
      return {
        ...state,
        transferStockLocations: action.response.results,
        pending: false,
        error: []
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/transferStockLocations.js